import { post } from '@/util/http'

/**
 * 新增实体
 *
 * @param {Object} vo 接收新增参数的VO对象
 * @return Result
 */
export const insertPlanActivity = params => post(`/plan/planActivity/insert`, params);
/**
 * 根据id更新实体, 全部字段覆盖更新
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateAllColumnPlanActivity = params => post(`/plan/planActivity/updateAllColumn`, params);
/**
 * 根据id列表批量更新非空字段
 *
 * @param {Object} vo        更新非空字段
 * @param {Object} listParam ListParam.lsIds批量更新的id列表
 * @return Result
 */
export const updateBatchPlanActivity = params => post(`/plan/planActivity/updateBatch`, params);
/**
 * 根据id删除实体
 *
 * @param {String} id 删除该id的实体
 * @return Result
 */
export const deleteByIdPlanActivity = params => post(`/plan/planActivity/deleteById`, params);
/**
 * 根据id列表批量删除数据
 *
 * @param {Object} listParam ListParam.lsIds批量删除的id列表
 * @return Result
 */
export const deleteBatchIdsPlanActivity = params => post(`/plan/planActivity/deleteBatchIds`, params);
/**
 * 获取查询列表
 *
 * @param vo 接收查询参数的VO对象, 支持fuzzyText属性模糊查询
 * @return Result
 */
export const selectListPlanActivity = params => post(`/plan/planActivity/selectList`, params);
/**
 * 分页查询获取列表
 *
 * @param {Object} pager 通用查询分页对象
 * @param {Object} vo    接收查询参数的VO对象, 支持fuzzyText属性模糊查询
 * @return Result
 */
export const selectPagePlanActivity = params => post(`/plan/planActivity/selectPage`, params);
/**
 * 根据id更新实体，仅更新非空字段
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updatePlanActivity = params => post(`/plan/planActivity/update`, params);
/**
 * 获取查询结果统计记录数
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const selectCountPlanActivity = params => post(`/plan/planActivity/selectCount`, params);


/**
 * 获取机构下年度计划附件
 *
 * @return Result
 */
export const getOrgActivityAttachment = params => post(`/plan/summary/attachment/select`, params);
/**
 * 删除年度总结附件
 *
 * @return Result
 */
export const deleteActivityAttachment = (params) => post(`/plan/summary/attachment/delete`, params, {responseType: 'arraybuffer'});
/**
 * 获取计划活动下的所有附件
 */
export const getActivityAttachment = params => post(`/plan/attachment/select`, params);
/**
 * 删除附件
 *
 * @return Result
 */
export const deleteAttachment = (params) => post(`/plan/attachment/delete`, params, {responseType: 'arraybuffer'});
